export default class Autocompleters {

  constructor() {
    // input fieelds to complete
    this.firstNameField = document.getElementById('name');
    this.lastNameField = document.getElementById('surname');
    this.emailField = document.getElementById('email');

    // facebook trigging
    this.triggerFb = document.querySelector('[data-social-login="facebook"]');
    if(this.triggerFb !== null){
        this.triggerFb.addEventListener('click', ()=>{ this.temporaryClick() });
    }
  }

  temporaryClick(){
      window.open('https://www.istitutomarangoni.com/landing_pages/fb-autofill',
          '',
          'left=100, top=100, height=500, width=700, directories=no, fullscreen=no, location=no, menubar=no, resizable=no, scrollbars=yes, status=yes, titlebar=no, toolbar=no');
  }

  checkFbLogin() {
    FB.getLoginStatus( (response) => {
        if (response.status === 'connected') {
            this.setFbData(response.authResponse.userID);
          } else {
            FB.login( (response) => {
                console.log(response.authResponse);
              if (response.authResponse) {
                    this.setFbData(response.authResponse.userID)
              } else {
                console.log('facebook user has not logged in from modal');
              }
            }, {scope: 'first_name, last_name, email'});
          }
    });
  }

  setFbData(userId){
      FB.api(
          userId,
          function (response){
              console.dir(response);
              this.firstNameField.value = response.first_name;
              this.lastNameField.value = response.last_name;
              this.emailField.value = response.email;
          }
      );
  }

}


